import { t } from 'i18next'
import * as z from 'zod'

import { EmployeeLoginFormVO } from './type'

export const schema = z.object({
  userId: z.string().min(1, t('auth.validation.required')),
  password: z.string().min(1, t('auth.validation.required')),
})

export const formLabels: Record<keyof EmployeeLoginFormVO, string> = {
  userId: t('auth.login.userId'),
  password: t('auth.login.password'),
}

export const defaultValues: EmployeeLoginFormVO = {
  userId: '',
  password: '',
}
